import JSZip from 'jszip';
import AuthenticatedComponent from './AuthenticatedComponent';
import configuration from '../config';

const authenticatedComponent = new AuthenticatedComponent();

async function createZipAndDownload(gxId, nameAppend, urls, setProcessing) {
  const zip = new JSZip();

  try {
    await Promise.all(
      urls.map(async (url) => {
        let fileName =
          url
            .substring(url.length - 28)
            .replaceAll('.pdf', '')
            .replaceAll('-', '_')
            .replaceAll('_to_', '-') + `_${nameAppend}.pdf`;

        const response = await fetch(
          // 'https://demo01.elexity.net:447'
          configuration['backend_host'] +
            '/ahiapi/' +
            gxId +
            '/gridInterconnect/bills/pdf?uri=' +
            url,
          {
            headers: authenticatedComponent.generateAuthenticatedHeader(),
          }
        );

        if (!response.ok) {
          throw new Error(`Failed to fetch ${url}: ${response.status} ${response.statusText}`);
        }

        const blob = await response.blob();
        zip.file(fileName, blob);
      })
    );

    const zipBlob = await zip.generateAsync({ type: 'blob' });
    const downloadLink = document.createElement('a');
    downloadLink.href = URL.createObjectURL(zipBlob);
    downloadLink.download = 'allBills.zip';
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  } catch (error) {
    console.error('An error occurred:', error);
  }

  setProcessing(false);
}

export { createZipAndDownload };
